import focus from '@alpinejs/focus';
import { Fancybox } from '@fancyapps/ui';
import '@tailwindplus/elements';
import Alpine from 'alpinejs';

import initAccordion from './components/accordion';
import initCalendarSlider from './components/calendarSlider';
import initCookieConsent from './components/cookieConsent';
import initDealersModal from './components/dealersModal';
import initHeaderSlider from './components/headerSlider';
import initHeaderVideo from './components/headerVideo';
import initImagesSlider from './components/imagesSlider';
import initLogoSlider from './components/logoSlider';
import initMenu from './components/menu';
import initProgressCircle from './components/progressCircle';
import initProjectsFilter from './components/projectsFilter';
import initProjectsSlider from './components/projectsSlider';
import initTabSlider from './components/tabSlider';
import initTeamMember from './components/teamMember';
import initTestimonials from './components/testimonials';
import initTimeline from './components/timeline';
import initVideo from './components/video';
import initStyles from './plugins/jsStyles';

Alpine.plugin(focus);
window.Alpine = Alpine;

const startingWith = (
  subject: string,
  replacement: string,
) => ({ name, value }: { name: string; value: string | (() => unknown) }) => {
  let newName = name;
  if (newName.startsWith(subject)) {
    newName = newName.replace(subject, replacement);
  }
  return { name: newName, value };
};

document.addEventListener('alpine:init', () => {
  Alpine.prefix('data-x-');
  Alpine.mapAttributes(startingWith('data-x-ref', Alpine.prefixed('ref')));
  Alpine.mapAttributes(startingWith('data-x-on.', Alpine.prefixed('on:')));
  Alpine.mapAttributes(startingWith('data-x-bind.', Alpine.prefixed('bind:')));
  Alpine.mapAttributes(startingWith('data-x-cloak', Alpine.prefixed('cloak')));
  Alpine.mapAttributes(startingWith('data-x-transition.', Alpine.prefixed('transition:')));
  Alpine.mapAttributes(startingWith('data-x-trap', Alpine.prefixed('trap')));
  initAccordion();
  initCalendarSlider();
  initCookieConsent();
  initDealersModal();
  initHeaderSlider();
  initHeaderVideo();
  initImagesSlider();
  initLogoSlider();
  initMenu();
  initProjectsFilter();
  initProjectsSlider();
  initTabSlider();
  initTeamMember();
  initTestimonials();
  initTimeline();
  initVideo();
  initProgressCircle();
  initStyles();

  Fancybox.bind('[data-fancybox]', {});
});

Alpine.start();

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    // Handle hot module replacement
    // eslint-disable-next-line no-console
    console.log('HMR');
  });
}
